import { render } from "./StrategicSuitabilityTab.vue?vue&type=template&id=4a10dbfa&scoped=true"
import script from "./StrategicSuitabilityTab.vue?vue&type=script&lang=js"
export * from "./StrategicSuitabilityTab.vue?vue&type=script&lang=js"

import "./StrategicSuitabilityTab.vue?vue&type=style&index=0&id=4a10dbfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a10dbfa"]])

export default __exports__